import "./Header.scss";
import logo from "../assets/chorus_logo.png";
import { AppContext } from "../../context/AppContext";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
// import RightSideBarPanel from "../SidePanel/RightSideBarPanel";

function Header() {
  const { entityName } = useContext(AppContext);
  const location = useLocation();

  // Split path -> ["publisher", "publication-analytics"]
  const segments = location.pathname.split("/").filter(Boolean);

  const validRoots = ["publisher", "institutions", "funder"];

  const showRightSidebar =
    segments.length >= 2 && validRoots.includes(segments[0]);

  return (
    <>
      {!location.pathname.includes("search-funder") && (
        <div className="header-container border border-end-0 shadow-sm">
          <div className="header-item d-flex align-items-center justify-content-between">
            {/* Left section */}
            <div className="d-flex align-items-center">
              <img
                src={logo}
                alt="Chorus Logo"
                className="img-fluid logo-img"
              />

              {entityName ? (
                <>
                  <div className="vertical-line mx-2 bg-theme rounded align-self-stretch"></div>
                  <h4 className="text-uppercase my-0 py-1">{entityName}</h4>
                </>
              ) : (
                <span className="mx-2">Advancing Open Access to Research</span>
              )}
            </div>
            {/* Right section (mobile only) */}
            {showRightSidebar && (
              <div className="mobile-hamburger">
                {/* <RightSideBarPanel /> */}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
